import React from 'react';
import { Player } from '../../types/game';
import { getAvatarUrl } from '../../utils/avatar';
import { useTheme } from '../../contexts/ThemeContext';

interface LeaderboardScreenProps {
  players: Player[];
  currentPlayerName: string;
}

const LeaderboardScreen: React.FC<LeaderboardScreenProps> = ({ players, currentPlayerName }) => {
  const { theme } = useTheme();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 animate-[fadeIn_0.3s_ease-in]">
      <div
        className="rounded-3xl p-8 max-w-3xl w-full shadow-2xl backdrop-blur-md"
        style={{ backgroundColor: theme.colors.cardBackground }}
      >
        <div className="text-center mb-8">
          <div className="text-4xl mb-4">🏆</div>
          <h2
            className="text-3xl font-bold"
            style={{ color: theme.colors.textPrimary }}
          >
            Leaderboard
          </h2>
        </div>

        <div className="space-y-3 mb-8 max-h-80 overflow-y-auto">
          {players.map((player, index) => {
            const isCurrentPlayer = player.name === currentPlayerName;
            const medal = index === 0 ? '🥇' : index === 1 ? '🥈' : index === 2 ? '🥉' : '⭐';
            const baseClasses = 'flex items-center gap-3 p-4 rounded-2xl font-bold transition-all duration-300 transform hover:scale-105';

            return (
              <div
                key={player.id}
                className={`${baseClasses} ${isCurrentPlayer ? 'shadow-lg border-3' : 'border-2'}`}
                style={{
                  background: isCurrentPlayer ? theme.colors.accent : 'rgba(255, 255, 255, 0.8)',
                  color: isCurrentPlayer ? '#000' : theme.colors.textPrimary,
                  borderColor: isCurrentPlayer ? theme.colors.accent : 'rgba(255, 255, 255, 0.3)'
                }}
              >
                <span className="text-xl">{medal}</span>
                <img
                  src={getAvatarUrl(player.name, 64)}
                  alt={`${player.name}'s avatar`}
                  className="w-10 h-10 rounded-full border-2"
                  style={{ borderColor: isCurrentPlayer ? '#000' : 'rgba(255, 255, 255, 0.5)' }}
                />
                <span className="flex-1 text-center text-lg">{player.name}</span>
                <span className="text-lg font-bold">{player.score} pts</span>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <div className="animate-bounce text-2xl mb-2">🚀</div>
          <p
            className="font-medium"
            style={{ color: theme.colors.textSecondary }}
          >
            Get ready for the next brain-buster!
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardScreen;